import {
  FileExcelOutlined,
  FileGifOutlined,
  FileImageOutlined,
  FileJpgOutlined,
  FileMarkdownOutlined,
  FileOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FileZipOutlined,
} from '@ant-design/icons';
import { FILE_ICON } from '.';

const fileIcons = {
  xlsx: FileExcelOutlined,
  docx: FileWordOutlined,
  gif: FileGifOutlined,
  png: FileImageOutlined,
  jpg: FileJpgOutlined,
  jpeg: FileJpgOutlined,
  md: FileMarkdownOutlined,
  pdf: FilePdfOutlined,
  pptx: FilePptOutlined,
  txt: FileTextOutlined,
  zip: FileZipOutlined,
  rar: FileZipOutlined,
};

export type FileIconProps = {
  /**
   * Available extensions: "xlsx" | "docx" | "gif" | "png" | "jpg" | "jpeg" | "md" | "pdf" | "pptx" | "txt" | "zip" | "rar".
   */
  ext?: string;
  /**
   * Size of icon ex: 80.
   */
  size?: number;
};

export const FileIcon = ({ ext, size = 80 }: FileIconProps) => {
  if (ext && Object.keys(fileIcons).includes(ext)) {
    const FileIconRender = fileIcons[ext as keyof typeof fileIcons];
    return <FileIconRender style={{ fontSize: size }} data-testid={FILE_ICON} title={ext} />;
  }

  if (!ext) return <FileOutlined title={ext} style={{ fontSize: size }} />;
};
